import * as React from "react";

import {MemberFile} from "./memberFilesSlice";
import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import Loader from "../ui/Loader";
import {downloadBook} from "../eLibrary/eBookFunctions";

const MemberFiles = () => {

  const {editedFiles, processingFiles, filesUpdateStatus} = useAppSelector((store) => store.memberFilesState);

  const dispatch = useAppDispatch();

  if (!editedFiles.length && !processingFiles.length) {
    return null
  }

  if (filesUpdateStatus === "loading") {
    return (
      <section className="section relative padding-t-0 padding-b-0 min-h-170" id="section-files">
        <Loader/>
      </section>
    )
  }

  return (
    <section className="section relative padding-t-0 padding-b-0 min-h-170" id="section-files">
      <div className="container">
        <div className="flex flex--top flex--column-book">
          <div className="flex-item col col--big">
            <div className="member-item member-item--border-right">
              <div className="flex flex--start member-item__title">
                <span className="member-item__icon member-item__icon--checkbox"></span>
                <span className="h4">Edited files</span>
              </div>
              <ul className="ui-list ui-list--with-checkmarks ui-list--member">
                {editedFiles.length ? editedFiles.map((memberFile: MemberFile, memberFileIndex:number) => {
                  return (
                    <li className="ui-list__item" key={memberFile.fileName + memberFileIndex}>
                      <span className="h5 blue2 bold link link--file link--dashed"
                         onClick={() => downloadBook({downloadUrl: memberFile.link, title: memberFile.fileName}, dispatch)}>
                        {memberFile.fileName}
                      </span>
                    </li>
                  )
                }) : (
                  <span className="h5 gray2 opacity-50">Submit your media for expert editing.</span>
                )}
              </ul>
            </div>
          </div>
          <div className="flex-item col col--big">
            <div className="member-item">
              <div className="flex flex--start member-item__title">
                <span className="member-item__icon member-item__icon--refresh"></span>
                <span className="h4">Files in the progress...</span>
              </div>
              <ul className="ui-list opacity-50 ui-list--member">
                {processingFiles.length ? processingFiles.map((file, fileIndex:number) => {
                  return (
                    <li className="ui-list__item" key={file.fileName + fileIndex}>
                      <a className="h5 blue2 bold link link--file link--dashed" href={file.link}>{file.fileName}</a>
                    </li>
                  )
                }) : (
                  <span className="h5 gray2">Submit your media for expert editing.</span>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MemberFiles